/*
 * JS For Home Page Slider
 * epicaffect
 */

(function(window,document,$){
    
$('.home-page-slider').slick({
	autoplay: true,
	autoplaySpeed: 5000,
	arrows: false,
	draggable: false,
	dots: false,
	fade: true
});

})(window,document,jQuery);

